import React, { useState, useEffect } from 'react';

const QuoteGenerator: React.FC = () => {
    const [quote, setQuote] = useState<string>('');
    const [author, setAuthor] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchQuote = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch('https://proxy.cors.sh/https://zenquotes.io/api/random');
            
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            
            setQuote(data[0].q);
            setAuthor(data[0].a);

        } catch (error) {
            setError('Zitat konnte nicht geladen werden. Bitte versuche es später erneut.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchQuote();
    }, []);

    return (
        <div className="quote-box">
            {loading && <p>Lade inspirierende Worte...</p>}
            {error && <p>{error}</p>}
            {!loading && !error && (
                <blockquote className="quote-text">
                    "{quote}"
                    <p>- {author}</p>
                </blockquote>
            )}
            <button className="quote-button" onClick={fetchQuote}>Neues Zitat</button>
        </div>
    );
};

export default QuoteGenerator;